import React, { useEffect } from "react";
import { useAuth } from "react-uicomp";
import CompWrapper from "../../hoc/compWrapper/CompWrapper.hoc";
import Title from "../../common/title/Title.common";

import WORKING_STRATEGIES from "../../../assets/images/workingStrategies.PNG";
export const WorkingStrategies = () => {
  const { setHeaderTitle } = useAuth();

  useEffect(() => {
    setHeaderTitle("Working Strategies");
  }, [setHeaderTitle]);
  return (
    <CompWrapper>
      <Title title="Working Strategies" hide_SeeAll />
      <div className="working-Strategies">
        <div className="working-strategies-image">
          <img src={WORKING_STRATEGIES} width="70%" height="70%" />
        </div>
      </div>
    </CompWrapper>
  );
};
